module.exports = __webpack_public_path__ + "img/vk.29726918.png";